// frontend/src/components/SEOHead.js
import React from 'react';
import { useLocation } from 'react-router-dom';
import { getFullImageUrl } from '../services/api';

const SEOHead = ({ 
  title, 
  description, 
  keywords, 
  image, 
  canonical,
  type = 'website',
  article = null 
}) => {
  const location = useLocation();
  const baseUrl = 'http://localhost:3000';
  
  // استفاده از مقادیر پیشفرض اگر ارائه نشده باشند
  const seoTitle = title || "گروه صنعتی تکنو پلیمر اسپادانا - قالب سازی و لاستیک سازی";
  const seoDescription = description || " گروه صنعتی تکنو پلیمر اسپادانا طراحی و ساخت انواع قالب های لاستیک و تولید انواع قطعات لاستیکی از جمله اورینگ، پکینگ، قطعات صنعتی و خودرویی با انواع متریال (EPDM, HNBR, VITON, SILICON, SBR, NBR)";
  const seoKeywords = keywords || 'قالب سازی، لاستیک سازی';
  const seoImage = getFullImageUrl(image) || getFullImageUrl('/static/images/og-default.jpg');
  const seoCanonical = canonical || `${baseUrl}${location.pathname}`;
  const seoType = type;

  // ساخت داده‌های ساختاریافته Schema.org
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "تکنو پلیمر اسپادانا",
    "url": baseUrl,
    "logo": `${baseUrl}/static/images/logo.png`,
    "description": seoDescription,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "اصفهان، خیابان امام خمینی، خیابان بسیج",
      "addressLocality": "اصفهان",
      "addressCountry": "IR"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+98-31-91550821",
      "contactType": "customer service"
    }
  };

  // اگر مقاله است، schema مقاله اضافه شود
  const articleSchema = article ? {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": article.title,
    "description": article.description,
    "image": article.image,
    "datePublished": article.publishedDate,
    "dateModified": article.modifiedDate,
    "author": {
      "@type": "Person",
      "name": article.author
    }
  } : null;

  return (
    <>
      {/* Primary Meta Tags */}
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={seoKeywords} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={seoCanonical} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={seoType} />
      <meta property="og:url" content={seoCanonical} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:site_name" content="BusinessPro" />
      <meta property="og:locale" content="fa_IR" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={seoCanonical} />
      <meta property="twitter:title" content={seoTitle} />
      <meta property="twitter:description" content={seoDescription} />
      <meta property="twitter:image" content={seoImage} />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
      
      {articleSchema && (
        <script type="application/ld+json">
          {JSON.stringify(articleSchema)}
        </script>
      )}

      {/* Additional Meta Tags */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="theme-color" content="#000000" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black" />
      
      {/* Favicon */}
      <link rel="icon" href="/favicon.ico" />
      <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
    </>
  );
};

export default SEOHead;